import React from 'react';

import { Box } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { DeliveryProgress } from 'components/order-status/components/delivery-progress/delivery-progress';
import { useOrderStatusDetail } from 'components/order-status/use-order-status-details';
import { useNavigation } from 'hooks/navigation/use-navigation';
import { CustomEventNames, EventTypes, useMParticleContext } from 'state/mParticle';
import { routes } from 'utils/routing';

import { ItemThumbnailWithBadge } from './components/item-thumbnail-with-badge/item-thumbnail-with-badge';
import {
  ActionButtonStyled,
  Card,
  CardContainer,
  LeftContainer,
  OrderNumber,
  RightContainer,
  ServiceModeContainer,
  ServiceModeLabel,
} from './styled';

export const OrderStatusCard = () => {
  const { formatMessage } = useIntl();
  const { linkTo } = useNavigation();
  const { logEvent } = useMParticleContext();
  const orderStatusDetail = useOrderStatusDetail();

  if (!orderStatusDetail) {
    return null;
  }

  const {
    orderNumber,
    icon,
    heading,
    details,
    deliveryStatus,
    image,
    name,
    totalItems,
    orderId,
  } = orderStatusDetail;

  return (
    <CardContainer>
      <Card>
        <LeftContainer>
          <OrderNumber>
            {orderNumber && formatMessage({ id: 'orderConfirmationNumber' }, { orderNumber })}
          </OrderNumber>
          <ServiceModeContainer>
            {icon}
            <ServiceModeLabel>{heading}</ServiceModeLabel>
          </ServiceModeContainer>
          {details}
          {deliveryStatus && (
            <Box w={'5/6'}>
              <DeliveryProgress deliveryStatus={deliveryStatus} />
            </Box>
          )}
        </LeftContainer>
        <RightContainer>
          <ItemThumbnailWithBadge image={image} name={name} totalItems={totalItems} />
          <ActionButtonStyled
            onPress={() => {
              logEvent(CustomEventNames.ORDER_STATUS_CARD_ORDER_DETAIL_CLICK, EventTypes.Other);
              linkTo(`${routes.orderConfirmation}/${orderId}`);
            }}
          >
            {formatMessage({ id: 'orderDetailsHeading' })}
          </ActionButtonStyled>
        </RightContainer>
      </Card>
    </CardContainer>
  );
};
